import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Layout from './pages/LandingHome/Layout';
import Ulayout from './pages/Ulayout/Ulayout';
import UcollectionList from '../src/components/Uwebsite/UcollectionsListComp/UcollectionList';
import BloomlayoutPage from './pages/BloomLayout/BloomlayoutPage';
import BloomCollectionlist from './components/BloomComp/BloomCollectionListComp/BloomCollectionlist';
import BlesslayoutPage from './pages/BlessLayout/BlesslayoutPage';
import BlessCollectionList from './components/BlessComp/BlessCollectionList/BlessCollectionList';
import AddtoCart from './components/AddtoCartComp/AddtoCart';
import { CartProvider } from './components/CartContext/CartContextComp';
import CheckOutPage from './pages/CheckOutLayout/CheckOutPage';
import CartPage from './pages/CartLayout/CartPage';
import { fetchGuestToken } from '../src/ApiServices/ApiServices';
import OrderSuccess from './components/OrderSuccessComp/OrderSuccess';
import PrivacyPolicyPage from './pages/PrivacyPolicyLayout/PrivacyPolicyPage';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  useEffect(() => {
    fetchGuestToken();
  }, []);

  return (
    <div className="App">
      <CartProvider>
        <Router basename='/'>
          <Routes>
            <Route path="/" element={<Layout />} />
            <Route path="/umadras" element={<Ulayout />} />
            <Route path="/umadras/collections" element={<UcollectionList />} />
            <Route path="/umadras/collections/product/:id" element={<AddtoCart />} />

            <Route path="/bloom" element={<BloomlayoutPage />} />
            <Route path="/bloom/collections" element={<BloomCollectionlist />} />
            <Route path="/bloom/collections/product/:id" element={<AddtoCart />} />

            <Route path="/bless" element={<BlesslayoutPage />} />
            <Route path="/bless/collections" element={<BlessCollectionList />} />
            <Route path="/bless/collections/product/:id" element={<AddtoCart />} />

            <Route path="/checkout" element={<CheckOutPage />} />
            <Route path="/cart" element={<CartPage />} />
            
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

            <Route path="/success" element={<OrderSuccess />} />
          </Routes>
        </Router>
        <WhatsAppButton />
      </CartProvider>
    </div>
  );
}

export default App;